<script>
  import { HStack, Spacer, Fixed, MediaQuery } from "./layout";
  import { Button, Icon } from "./widget";
  import { showNotImplemented } from "../dialog.js";

  //export let id;
</script>

<article>
  <MediaQuery query="(min-width: 481px)">
    <section>
      <Spacer />
      <img src="/images/budget2.png" alt="budget" width="48px" />
      <span>Budget</span>
      <button class="primary" on:click={showNotImplemented}>Gérer</button>
      <Spacer />
    </section>
  </MediaQuery>
  <MediaQuery query="(max-width: 480px)">
    <Button action={showNotImplemented}>
      <HStack alignment="center">
        <img src="/images/budget2.png" alt="budget" width="48px" />
        <span>Budget</span>
        <Spacer />
        <Icon name="chevron-right" />
        <Fixed />
      </HStack>
    </Button>
  </MediaQuery>
</article>

<style>
  article {
    width: 100%;
    min-height: 48px;
    background-color: white;
    margin-top: 5px;
    padding-top: 5px;
  }
  span {
    margin-left: 1em;
  }

  @media (min-width: 481px) {
    article {
      /*height: 0;*/
      padding: 1em;
      padding-top: 15%;
      background-color: white;
      width: auto;
      position: relative;
      border-radius: 50%;
      min-width: 120px;
    }
    section {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    span {
      margin-left: 0;
    }
  }
</style>
